




















import { defineComponent, computed } from '@vue/composition-api';

import {
  getProvinces,
} from '@/api';

const CommonProvinceSelector = defineComponent({
  props: {
    label: {
      type: String,
      default() { return 'จังหวัด'; },
    },
    value: {
      type: [Object],
      default() { return null; },
    },
    level: {},
    showLabel: { default: false },
    rules: { default: '' },
    showAsEnglish: { default: false },
  },
  setup(props: any) {
    const getProvincesResult = (data: any) => data;
    const _value = computed(() => props.value);

    return {
      getProvinces,
      getProvincesResult,
      _value,
    };
  },
});

export default CommonProvinceSelector;
